// Coming Soon products: shown to customers, but they can't be added to the cart
// until the store takes the mark off. It counts only while the store has the
// Coming Soon feature switched on by the super admin — the server applies the
// same rule (pricing.is_coming_soon) and refuses such items at checkout.

export const storeHasComingSoon = (storeSettings) =>
  storeSettings?.tenant_features?.coming_soon === true;

export const isComingSoon = (product, storeSettings) =>
  storeHasComingSoon(storeSettings) && product?.is_coming_soon === true;
